import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PDxListItem, PDxLists } from 'src/app/core/PDxListItem.model';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { UserInformation } from './user-information.model';
import { DirtyTrackingDirective } from 'src/app/core/dirty-tracking/dirty-tracking.directive';
import { FocusMeDirective } from 'src/app/core/focus-me/focus-me.directive';

@Component({
  selector: 'app-user-properties',
  templateUrl: './user-properties.component.html',
  styles: [
  ]
})
export class UserPropertiesComponent implements OnInit {

  @Input() userId: string;

  user: UserInformation = new UserInformation();
  submitAttempt: boolean = false;

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.userId) {
      this.ajax.MakeCall<UserInformation>('/User/Get', { userId: this.userId }).then((data) => { this.user = data; }, () => { });
    } else {
      this.user.isPDxAdmin = true;
      this.user.isActive = true;
    }
  }

  save(f: NgForm): void {
    this.submitAttempt = true;
    if (f.invalid) {
      return;
    }
    this.ajax.MakeCall('/User/Save', this.user).then(() => {
      this.modal.close();
    }, () => { });
  }

  dismiss(): void {
    this.modal.dismiss();
  }
}
